import {
  Box,
  Button,
  Grid,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  withStyles,
} from '@material-ui/core'
import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Link } from 'react-router-dom'

import styles from '../../../resources/theme/global'
import { overdue, ready } from '../HomeActions'

import BaseRelatoryPage from '../../../components/hooks/BaseRelatoryPage'
import {
  StyledTableCellBody,
  StyledTableCellHeader,
} from '../../../components/hooks/BaseTableComponents'
import { exportFormatedMoney } from '../../../util/utils'
import OverdueItemsFilter from './OverdueItemsFilter'
import colors from '../../../assets/colors'

function OverdueItems(props) {
  const dispatch = useDispatch()
  const { classes } = props

  const items = useSelector(state => state.dashboard.overdueItems)

  useEffect(() => {
    dispatch(overdue())
  }, [])

  return (
    <BaseRelatoryPage title="Itens em atraso" goBack>
      <Grid container spacing={2} alignItems="center">
        <Grid item xs={12}>
          <OverdueItemsFilter classes={classes} />
        </Grid>

        <Grid item xs={12}>
          <TableContainer className={classes.tableStickHeader}>
            <Table stickyHeader>
              <TableHead>
                <TableRow>
                  <StyledTableCellHeader />
                  <StyledTableCellHeader>Número da OS</StyledTableCellHeader>
                  <StyledTableCellHeader>Etiqueta</StyledTableCellHeader>
                  <StyledTableCellHeader>Cliente</StyledTableCellHeader>
                  <StyledTableCellHeader>Atendente</StyledTableCellHeader>
                  <StyledTableCellHeader>Tipo de serviço</StyledTableCellHeader>
                  <StyledTableCellHeader>Status</StyledTableCellHeader>
                  <StyledTableCellHeader>Valor</StyledTableCellHeader>
                  <StyledTableCellHeader>Data da Coleta</StyledTableCellHeader>
                  <StyledTableCellHeader>
                    Previsão de Entrega
                  </StyledTableCellHeader>
                </TableRow>
              </TableHead>
              <TableBody key={`table-overdue-items-${items?.length}`}>
                {items?.map(item => (
                  <TableRow key={item.id}>
                    <TableCell style={{ width: '20px' }}>
                      <Box
                        style={{
                          height: '26px',
                          width: '2px',
                          borderRadius: '5px',
                          backgroundColor: colors.error,
                        }}
                      />
                    </TableCell>
                    <TableCell
                      component={Link}
                      to={`/attendance/${item.id}/edit`}
                    >
                      {item.id_laundry_client}
                    </TableCell>
                    <StyledTableCellBody>
                      {item?.bar_code || '-'}
                    </StyledTableCellBody>
                    <StyledTableCellBody>
                      {item.client_name}
                    </StyledTableCellBody>
                    <StyledTableCellBody>{item.user_name}</StyledTableCellBody>
                    <StyledTableCellBody>
                      {item.service_type}
                    </StyledTableCellBody>
                    <StyledTableCellBody>{item.status}</StyledTableCellBody>
                    <StyledTableCellBody>
                      {exportFormatedMoney(item?.value)}
                    </StyledTableCellBody>
                    <StyledTableCellBody>
                      {item.collected_at}
                    </StyledTableCellBody>
                    <StyledTableCellBody>
                      {item.deadline_date}
                    </StyledTableCellBody>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Grid>
      </Grid>
    </BaseRelatoryPage>
  )
}

export default withStyles(styles)(OverdueItems)
